export default __webpack_public_path__ + "static/media/emptyImage1.79f29b73.png";